export default "__VITE_PUBLIC_ASSET__a5b1a113__"